import { StatsData } from '@shared';

export const SCREENS_STATS: StatsData[] = [
    {
        title: 'Total Screens',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'screens',
        total: '200',
        stats: [
            { label: 'Active', value: '100', colorClass: 'text-orange-400' },
            { label: 'Inactive', value: '100', colorClass: 'text-blue-500' },
        ],
    },
    {
        title: 'New Screens this week',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'screens',
        total: '100',
        stats: [{ label: 'Last Week', value: '8.3%', colorClass: 'text-orange-400' }],
    },
    {
        title: 'New last week',
        description: 'Lorem ipsum description dolor.',
        iconKey: 'screens',
        total: '20',
        stats: [{ label: 'Last Week', value: '8.3%', colorClass: 'text-orange-400' }],
    },
];
